export class Designation {
  public id = '';
  public title = '';
  public amount = 0;
}
